













































import { defineComponent } from "@vue/composition-api";
import Multiselect from "vue-multiselect";
import { $t } from "@/lib/i18nHelpers";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "LandingMultiselect",
  components: { Multiselect, BaseIcon },
  props: {
    multiple: { type: Boolean, default: true },
    closeOnSelect: { type: Boolean, default: false },
    placeholder: { type: String, default: $t("Categories") },
  },
});
